<template>
  <div class="contents syain">
    <div class="list">
      <div class="col-item btn-container">
        <router-link :to="{ name: RouterConst.SYAIN_CREATE }" class="btn-link create"><i class="fa-solid fa-plus"></i> 新規追加
        </router-link>
      </div>
      <loading  v-if="isLoading"></loading>
      <template v-else>      
        <p><br>※部課や就業場所、労働条件に関する情報は現時点で有効な雇用契約に基づく内容が表示されます。</p>
        <scroll-table>
          <table class="list-table">
            <thead>
              <tr>
                <th class="buka">部課</th>
                <th class="nyuusya">入社日</th>
                <th class="code">社員番号</th>
                <th class="name" colspan="2">氏名</th>
                <th class="kana">フリガナ</th>
                <th class="syozoku">所属</th>
                <th class="syuugyou_basyo">就業場所</th>
                <th class="shikaku">資格</th>
                <th class="shikaku">権限ロール</th>
                <th class="koyou_keitai">雇用形態</th>
                <th class="muki_date">無期転換日</th>
                <th class="syubetsu">種別</th>
                <th class="shimebi">締日</th>
                <th class="syakai_hoken">社保</th>
                <th class="koyou_hoken">雇用</th>
                <th class="notes">備考</th>
                <th class="taisyoku_date">退職日</th>
                <th class="birthday">生年月日</th>
                <th class="age">年齢</th>
                <th class="kinzoku_nesuu">勤続年数</th>
                <th class="kinzoku_nissuu">勤続日数</th>
                <th class="hokensyou">保険証番号</th>
                <th class="web_meisai">web明細</th>
                <th class="koutsuuhi">交通費</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in dataList">
                <template v-if="dataList.length > 0">
                  <tr :key="index">
                    <td>{{ item.bukaName }}</td>
                    <td>{{ dateFormat(item.nyuusya_date) }}</td>
                    <td>{{ item.staff_code }}</td>
                    <td class="name">
                      <router-link :to="{ name: RouterConst.SYAIN_DETAIL, params: { id: item.user_id }  }" class="btn-detail"> {{ item.staff_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="{ name: RouterConst.SYAIN_EDIT, params: { id: item.user_id }  }">
                        <i class="fa-solid fa-pen btn-edit"></i>
                      </router-link>
                    </td>
                    <td>{{ item.staff_kana }}</td>
                    <td>{{ item.syozoku_name }}</td>
                    <td>{{ item.syuugyouBasyoName }}</td>
                    <td>{{ item.shikaku_notes }}</td>
                    <td>{{ item.role_name }}</td>
                    <td>{{ item.keitai }}</td>
                    <td>{{ item.keiyakuDate}}</td>
                    <td>{{ item.syubetsu }}</td>
                    <td>{{ item.shimeDay }}</td>
                    <td>{{ item.syaho }}</td>
                    <td>{{ item.koyou }}</td>
                    <td>{{ item.notes }}</td>
                    <td>{{ dateFormat(item.taisyoku_date) }}</td>
                    <td>{{ dateFormat(item.birthday_date) }}</td>
                    <td>{{ item.age }}</td>
                    <td>{{ item.kinzokuNensuu }}</td>
                    <td>{{ item.kinzokuNissuu }}</td>
                    <td>{{ item.hokensyou_no }}</td>
                    <td>{{ item.webMeisai }}</td>
                    <td>{{ item.koutsuuhi }}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </scroll-table>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent} from "vue"
import { dateFormat } from "@/filters/common"
import { ListData } from "@/types/Syain";
import { RouterConst } from "@/const/Router";
import { useAuthStore } from "@/store/auth";

export default defineComponent({
  props: {
    dataList: {
      type: Array as () => ListData[],
      default: null
    },
    isLoading: {
      type: Boolean,
    },
  },
  setup(props) {
    const authStore = useAuthStore()

    return {
      dateFormat,
      RouterConst,
      authStore
    };
  },
  components: {
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-list.scss';
</style>